// Tek kaynak: slug (DB) <-> Turkce etiket (UI). appointments.source'daki mevcut
// ASCII-slug kuraliyla tutarli - enum DB'de bosluksuz/Turkce karaktersiz kalir,
// kullanicinin istedigi Turkce etiketler sadece UI katmaninda gorunur.
export const LEAD_STATUSES = [
  { slug: 'not_called', label: 'Aranmadı', color: '#94a3b8' },
  { slug: 'called', label: 'Arandı', color: '#60a5fa' },
  { slug: 'spoke', label: 'Görüşüldü', color: '#818cf8' },
  { slug: 'positive', label: 'Olumlu', color: '#22c55e' },
  { slug: 'negative', label: 'Olumsuz', color: '#ef4444' },
  { slug: 'call_again', label: 'Tekrar Aranacak', color: '#f59e0b' },
  { slug: 'appointment', label: 'Randevulandı', color: '#8b5cf6' },
  { slug: 'pre_meeting', label: 'Ön Görüşme Yapıldı', color: '#0ea5e9' },
];

export const TERMINAL_STATUSES = ['positive', 'negative', 'appointment'];

const BY_SLUG = Object.fromEntries(LEAD_STATUSES.map(s => [s.slug, s]));

export const labelFor = (slug) => (BY_SLUG[slug] ? BY_SLUG[slug].label : slug);
export const colorFor = (slug) => (BY_SLUG[slug] ? BY_SLUG[slug].color : '#94a3b8');
